<template>
	<div class="layout-footer">
		<div class="grid grid-footer">
			<div class="col-12 md:col-4">
				<button class="p-link logo-tribunal">
					<img id="layout-menu-logo" src="assets/layout/images/logo_tribunal.png" alt="Tribunal de contas do Estado do Amazonas"/>
					Tribunal de Contas do Estado do Amazonas
				</button>
			</div>
			<div class="col-12 md:col-4">
				Sistema de Processos Seletivos {{ appVersion }} | API {{ apiVersion }}
			</div>
			<div class="col-12 md:col-4 footer-icons">
				<router-link to="/home">
				<button class="p-link">
					<i class="pi pi-home "></i>
				</button>
			</router-link>

			</div>
		</div>
	</div>
</template>

<script>

	import {version} from '../package'
	import ApiService from './service/ApiService';

	export default {
		name: "AppFooter",

		data: () => ({
    		appVersion:version,
			apiVersion: '--',
			apiService: null
  		}),

		created() {
			this.apiService = new ApiService();
			this.apiService.getVersao().then((data) => {
				this.apiVersion = data.versao;
			}).catch(() => {
				this.apiVersion = '--';
			});
		}
	}
</script>

<style scoped>

</style>
